import React from 'react';
import {
  Navbar,
  NavbarBrand,
  NavbarToggler,
  Collapse,
  Nav,
  NavItem,
  NavLink,
  Button,
  Container,
} from 'reactstrap';
import { Link } from 'react-router-dom';

interface HeaderProps {
  isScrolled: boolean;
  isNavOpen: boolean;
  toggleNav: () => void;
}

const Header: React.FC<HeaderProps> = ({ isScrolled, isNavOpen, toggleNav }) => {
  return (
    <header>
      <Navbar
        color="light"
        light
        expand="lg"
        fixed="top"
        className={`shadow-sm transition-all duration-300 ${
          isScrolled ? 'bg-white' : 'bg-transparent'
        }`}
        aria-label="Main navigation"
      >
        <Container>
          <NavbarBrand href="/">
            <img
              src="https://placehold.co/200x60/ffffff/1e40af?text=SaaS+Logo&font=Inter"
              alt="SaaS Platform Logo"
              height="50"
            />
          </NavbarBrand>
          <NavbarToggler onClick={toggleNav} aria-label="Toggle navigation" />
          <Collapse isOpen={isNavOpen} navbar className="flex-grow-1">
            <div className="d-flex w-100 align-items-center justify-content-between">
              <Nav
                className="me-auto align-items-center"
                navbar
                style={{
                  display: 'flex',
                  flexWrap: 'nowrap',
                  overflowX: 'auto',
                  whiteSpace: 'nowrap',
                }}
              >
                <NavItem>
                  <NavLink href="#previews" className="px-3">
                    Previews
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink href="#features" className="px-3">
                    Features
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink href="#pricing" className="px-3">
                    Pricing
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink href="#testimonials" className="px-3">
                    Testimonials
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink href="/about" className="px-3">
                    About
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink href="/docs" className="px-3">
                    Documentation
                  </NavLink>
                </NavItem>
                <NavItem>
                  <Link to="/tickets/list" className="nav-link px-3">
                    Support
                  </Link>
                </NavItem>
              </Nav>
              <div className="ms-auto">
                <Button color="primary" size="sm">
                  <NavLink href="#tenant-request" className="text-white text-decoration-none">
                    Start Free Trial
                  </NavLink>
                </Button>
                <Button color="secondary" size="sm" className="ms-2">
                  <Link to="/login" className="text-white text-decoration-none">
                    Login
                  </Link>
                </Button>
              </div>
            </div>
          </Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default Header;
